module.exports = __webpack_public_path__ + "img/e5567978-93ef-4de1-804d-1f0e3654a014.8a4d45c.svg";